(() => {
  function initialize(root) {
    const controls = root.querySelector('[data-category-controls]');
    if (!controls || root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('[data-category-item]')];
    const buttons = [...controls.querySelectorAll('[data-kind]')];
    const available = controls.querySelector('[data-available]');
    const pages = root.querySelector('[data-category-pages]');
    let kind = buttons.some(b => b.dataset.kind === location.hash.slice(1)) ? location.hash.slice(1) : 'all';
    let page = 0;
    function render() {
      const matches = cards.filter(c => (kind === 'all' || c.dataset.kind === kind) && (!available.checked || c.dataset.available === 'true'));
      const count = Math.max(1, Math.ceil(matches.length / 12));
      page = Math.min(page, count - 1);
      const visible = new Set(matches.slice(page * 12, (page + 1) * 12));
      cards.forEach(c => { c.hidden = !visible.has(c); });
      buttons.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.kind === kind)));
      root.querySelector('[data-category-count]').textContent = `${matches.length} ${matches.length === 1 ? 'product' : 'products'}`;
      root.querySelector('[data-category-empty]').hidden = matches.length > 0;
      pages.hidden = count <= 1;
      pages.querySelector('[data-page-status]').textContent = `Page ${page + 1} of ${count}`;
      pages.querySelector('[data-page-back]').disabled = page === 0;
      pages.querySelector('[data-page-next]').disabled = page >= count - 1;
    }
    buttons.forEach(b => b.addEventListener('click', () => { kind = b.dataset.kind; page = 0; history.replaceState(null, '', `${location.pathname}${location.search}${kind === 'all' ? '' : '#' + kind}`); render(); }));
    available.addEventListener('change', () => { page = 0; render(); });
    pages.querySelector('[data-page-back]').addEventListener('click', () => { page--; render(); controls.scrollIntoView({block:'start'}); });
    pages.querySelector('[data-page-next]').addEventListener('click', () => { page++; render(); controls.scrollIntoView({block:'start'}); });
    window.addEventListener('hashchange', () => { kind = buttons.some(b => b.dataset.kind === location.hash.slice(1)) ? location.hash.slice(1) : 'all'; page = 0; render(); });
    controls.hidden = false;
    render();
  }
  document.querySelectorAll('[data-category-browser]').forEach(initialize);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-category-browser]').forEach(initialize));
})();
